module.exports = __webpack_public_path__ + "img/banner2.180ae8e9.png";